import { classNames } from '@src/components/common/util/classNames';
import { Col, Row, Typography } from 'antd';
import React, { ReactNode } from 'react';

const CSS_CLASS_VIEW_SECTION_ITEM_BASE = 'timun-viewSectionContent__item';

// -- Prop types
// ----------

interface IViewSectionContentItemOwnProps {
  icon: ReactNode;
  title: string | ReactNode;
  description?: string;
  actions?: ReactNode;
  className?: string;
}

type IViewSectionContentItemProps = IViewSectionContentItemOwnProps;

// -- Component
// ----------

class ViewSectionContentItem extends React.Component<IViewSectionContentItemProps> {
  render = () => {
    return <Row className={this.getClassName()} align="middle">
      <Col className="timun-viewSectionContent__icon" span={3}>
        {this.props.icon}
      </Col>
      <Col span={this.props.actions ? 15 : 21}>
        <Typography.Title className="timun-viewSectionContent__itemTitle" level={3}>{this.props.title}</Typography.Title>
        {this.props.description}
      </Col>
      {
        this.props.actions && <Col className="margin-auto" span={6}>
          {this.props.actions}
        </Col>
      }
    </Row>;
  };

  getClassName() {
    return classNames({
      [CSS_CLASS_VIEW_SECTION_ITEM_BASE]: true,
      [this.props.className || '']: true,
    });
  }
}

export default ViewSectionContentItem;
